import { render, staticRenderFns } from "./VideoTags.vue?vue&type=template&id=39e430a3&scoped=true&"
import script from "./VideoTags.vue?vue&type=script&lang=js&"
export * from "./VideoTags.vue?vue&type=script&lang=js&"
import style0 from "./VideoTags.vue?vue&type=style&index=0&id=39e430a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e430a3",
  null
  
)

export default component.exports